import { render, staticRenderFns } from "./HorizontalGameLists.vue?vue&type=template&id=165358d1&scoped=true&"
import script from "./HorizontalGameLists.vue?vue&type=script&lang=js&"
export * from "./HorizontalGameLists.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalGameLists.vue?vue&type=style&index=0&id=165358d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165358d1",
  null
  
)

export default component.exports